import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { SiteModel } from '@core/model/site.model';
import { utiles } from '@utl/environment';
import { CommonService } from './common.service';
import { AddressClassModel } from '@core/model/addressClass.model';
import { Injectable } from "@angular/core";
/*Constants */
const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

@Injectable()
export class SiteService {

  constructor(public http: HttpClient, private router: Router, private common: CommonService) {
    let data = utiles.getCacheUser();
    if (data !== null && data !== undefined) {
    } else {
      this.common._setLoading(false);
      this.router.navigate(['login']);
    }
  }

  getActiveSiteList() {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetActiveSiteList';
    return this.http.post<SiteModel[]>(url, null, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getActiveAddressList(CustAccount: string, ProjectId: string, UserId: number) {
    let vSearchAddress = new AddressClassModel();
    vSearchAddress.CustAccount = CustAccount;
    vSearchAddress.ProjectId = ProjectId;
    vSearchAddress.UserId = UserId;
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetActiveAddressList';
    return this.http.post<AddressClassModel[]>(url, JSON.stringify(vSearchAddress), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  setDefaultUserAddress(CustAccount: string, ProjectId: string, UserId: number, AddressId: string, AllowConfig: boolean) {
    let vSearchAddress = new AddressClassModel();
    vSearchAddress.CustAccount = CustAccount;
    vSearchAddress.ProjectId = ProjectId;
    vSearchAddress.UserId = UserId;
    vSearchAddress.AddressId = AddressId;
    vSearchAddress.AllowConfigAddress = AllowConfig;
    this.common._setLoading(true);
    const url = environment.apiURL + 'setDefaultUserAddress';
    return this.http.post<AddressClassModel[]>(url, JSON.stringify(vSearchAddress), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }
}

